import { useState } from 'react';
import PremiumIcon from '../../assets/premium.png';
import { Alert, AlertActions, AlertDescription, AlertTitle } from '../../catalyst/alert';
import { Button } from '../../catalyst/button';
import { Link } from '../../catalyst/link';
import { Strong, Text } from '../../catalyst/text';
import config from '../../config';

export default function PremiumPopupForSync (props) {
  const [open, setOpen] = useState(props.showPremiumPopupForSync);

  const handleClose = () => {
    setOpen(false)
    props.setShowPremiumPopupForSync(false);
  };

  return (
<>
<Alert open={open} onClose={() => {props.setShowPremiumPopupForSync(false);}}>
        <AlertTitle>Upgrade Premium</AlertTitle>
        <AlertDescription className="text-center">
        <div className="flex flex-col items-center space-y-4">
          <img
            src={PremiumIcon} // Replace with your image URL
            alt="Diamond"
            style={{ width: '100px', height: '100px' }}
          />
          <Text className="text-center">
            Sync is available for premium users only. 
            Go premium just for <Strong>$1.79</Strong>
          </Text>
        </div>
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={handleClose}>
            Close
          </Button>
          <Link href={config.premiumPath}><Button onClick={() => {}}>Go Premium for $1.79 !!</Button></Link>
        </AlertActions>
      </Alert>
    </>


  );
};
